import type { UserBrowserExtensionResults } from '@atlaskit/editor-common/utils/browser-extensions';
import { sniffUserBrowserExtensions } from '@atlaskit/editor-common/utils/browser-extensions';

export function getBrowserExtensions(): UserBrowserExtensionResults {
	return sniffUserBrowserExtensions({
		extensions: ['grammarly'],
	});
}
